<button>
    <ng-content></ng-content>
</button>
